<template>
    <div class="container">
        <loading-animation v-if="loading" minHeight="700" />
        <div v-else>
            <Form ref="info" :labelWidth="120">
                <!-- 合同信息 -->
                <contract-info
                    v-model="originalContract"
                    viewonly
                    justRead
                    title="原房源信息"
                    class="contract-content-class"
                />
                <Divider />
                <!-- 租客信息 -->
                <customer-info
                    v-model="cus"
                    prop="cus"
                    :type="routerType"
                    class="contract-content-class"
                    :isShowEditBtn="false"
                    :contractId="originalContract.id"
                    :houseName="originalContract.houseName"
                    disabledCusType
                    disabledUser
                    :cusMobileReadOnly="true"
                    :cusSourceReadOnly="true"
                />
                <Divider />
                <!-- 原租约信息 -->
                <lease-info-original
                    v-model="originalLease"
                    prop="leaseOriginal"
                    title="原租约信息"
                    :type="routerType"
                    :leaseLeftAmountTextOriginal="leaseLeftAmountTextOriginal"
                    class="contract-content-class"
                />
                <Divider />
                <!-- 费用清算 -->
                <expense-settlement
                    v-model="expenseSettlement"
                    class="contract-content-class"
                    prop="expense"
                    :discount="originalLease.discount"
                    :startDate="startDate"
                    :endDate="endDate"
                    :loading="loadingExpenseSettlement"
                    @on-condition-change="getExpenseSettlementList"
                    @on-bill-change="createBill"
                    @on-change="expenseDataChange"
                />
                <!-- 读数清算 -->
                <meter-settlement
                    v-model="meterSettlement"
                    v-if="meterSettlement.length"
                    prop="meter"
                    class="contract-content-class"
                />
                <Divider />
                <!-- 新房源选择 换房，房源只能是空置状态的-->
                <contract-info
                    v-model="contract"
                    prop="contract"
                    title="新房源选择"
                    class="contract-content-class"
                    houseStatus="1"
                    @onHouseChange="onHouseChange"
                />
                <Divider />
                <!-- 新租约信息 -->
                <lease-info
                    v-show="showLease"
                    prop="lease"
                    title="新租约信息"
                    class="contract-content-class"
                    :value="lease"
                    :type="routerType"
                    :leaseLeftAmountText="leaseLeftAmountText"
                    :depositHandleType="expenseSettlement.depositHandleType[0]"
                    :isRecvDeposit="isRecvDeposit"
                    @on-create-bills="createBill"
                />
            </Form>
            <!-- 账单信息 -->
            <bills-info
                :value="billView"
                class="contract-content-class"
                :loading="billLoading"
            />
            <div style="height: 100px"></div>
            <div class="btn-container">
                <Button
                    style="margin-right: 10px"
                    @click="submit"
                    type="primary"
                    >确定提交</Button
                >
                <Button @click="view">预览合同</Button>
            </div>
        </div>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showBillCorrection"
            title="账单修正"
            :width="1080"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="toContract"
        >
            <bill-correction v-if="modal.showBillCorrection" v-model="bills" />
        </smart-modal>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showChargeDetails"
            title="清算明细"
            :width="800"
            :height="600"
            :maskClosable="false"
        >
            <charge-details
                v-if="modal.showChargeDetails"
                :value="chargeDetails"
                :remark.sync="remark"
                change
                :maskClosable="false"
                :buttons="[]"
                @popChange="popChange"
            />
        </smart-modal>
    </div>
</template>

<script>
import {
    deepCopy,
    ymd,
    currency,
    officePreview,
    debounce,
    cent,
} from '_u/helper'
import Dict from '_u/dict'
import Enum from '_u/enum'
import {
    initExpenseSettlement,
    formateMeterSettlement,
    formateExpenseSettlement,
    formateLeaseReverse,
    formateContractAndView,
} from '_v/common/u-contract'
import mContract from '_v/common/m-contract'

import ContractInfo from './children/contract-info'
import CustomerInfo from './children/customer-info'
import LeaseInfo from './children/lease-info'
import LeaseInfoOriginal from './children/lease-info-original'
import ExpenseSettlement from './children/expense-settlement'
import MeterSettlement from './children/meter-settlement'
import BillsInfo from './children/bills-info'
import BillCorrection from './bill-correction'
import LoadingAnimation from '_v/components/loading-animation'
import ChargeDetails from '_v/components/charge-details'

import { houseRelDetail } from '@/api/assets'
import {
    contractView,
    contractPriview,
    contractChangeHouse,
    expenseBillListCreate,
    houseMeterList,
} from '@/api/contract'
import dayjs from "dayjs";

const CONTRACT_CHANGE_TYPE = Enum.get('CONTRACT_CHANGE_TYPE')

export default {
    name: 'contractExchange',
    mixins: [mContract],
    components: {
        ContractInfo,
        CustomerInfo,
        LeaseInfo,
        LeaseInfoOriginal,
        ExpenseSettlement,
        MeterSettlement,
        BillsInfo,
        BillCorrection,
        LoadingAnimation,
        ChargeDetails,
    },
    data() {
        return {
            loading: false,
            billLoading: false, // 生成账单loading
            loadingExpenseSettlement: false,
            showLease: false, // 是否展示新合约信息
            dict: {
                feeType: Dict.NULL,
                payType: Dict.NULL,
                meterType: this.$dict.NULL,
            },
            modal: {
                showBillCorrection: false,
                showChargeDetails: false,
            },
            id: this.$route.params.id,
            originalContract: {}, // 原合同信息
            contract: {}, // 合同信息
            cus: {}, // 租客信息
            originalLease: {}, // 原租约信息
            // 租约信息
            lease: {},
            facility: [], // 合同设施
            bills: [], // 账单信息
            payBills: [], // 待付账单——存储待付账单——账单修正不显示，创建合同需要合并到bills
            billInfo: [], // 账单信息——账单修正
            billView: [], // 账单信息——账单显示
            startDate: '', // 合同开始日期
            endDate: '', // 合同结束日期
            showSuccess: false,
            formData: '',
            // 费用清算
            expenseSettlement: {
                list: [],
                date: new Date(),
                depositHandleType: ['1'],
                isDeductionByLast: '1', // 是否直接抵做新房的租金
            },
            meterSettlement: [], // 读数清算
            metersJSON: '', // 读数清算JSON字符串
            chargeDetails: [], //费用明细
            remark: '',
            routerContractId: this.$route.query.contractId, // 合同id
            routerType: this.$route.query.type, // 合同操作类型 CONTRACT_SCENE
            isRecvDeposit: false, // 押金是否已收
            leaseLeftAmountText: '', // 其他押金与常规押金进行拼接字符串
            leaseLeftAmountTextOriginal: '', // 其他押金与常规押金进行拼接字符串
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            const changeDate = ymd(new Date())

            // 换房，请求原来合同的信息
            Promise.all([
                Dict.get(['fee_type', 'meter_type', 'pay_type']),
                contractView(this.routerContractId),
                expenseBillListCreate({
                    contractId: this.routerContractId,
                    changeDate,
                    changeType: CONTRACT_CHANGE_TYPE.exchange,
                    depositHandleType: this.expenseSettlement
                        .depositHandleType[0],
                }),
            ])
                .then((args) => {
                    var [dictGroup, view, expenseSettlement] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.formateView(view, expenseSettlement)

                    if (expenseSettlement.data.deposit) {
                        // 押金是否已收
                        this.isRecvDeposit =
                            expenseSettlement.data.deposit.billStatus === '2'
                    }
                    // 费用清算格式化
                    initExpenseSettlement(
                        expenseSettlement,
                        this.expenseSettlement
                    )
                    return houseMeterList(this.originalContract.houseId)
                })
                .then((meterSettlement) => {
                    this.initMeterSettlement(meterSettlement)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 房间更改，租约信息的房间信息更改
        onHouseChange(houseId) {
            var action = houseId
                ? houseRelDetail(houseId).then((res) => res.data.map)
                : Promise.resolve({})

            this.showLease = false
            action
                .then((room) => {
                    var lease = {
                        buildArea: room.buildArea || '',
                        unitPrice: room.unitPrice / 100 || '',
                        rent: room.rent / 100 || '',
                        minPrice: room.minPrice / 100 || '',
                        fList: room.faclityList || [],
                        otherFee: room.otherFeeList || [],
                        otherDeposit: room.otherDepositList || [],
                    }

                    lease.fList.forEach((v) => (v.price /= 100))
                    lease.otherFee.forEach((v) => (v.amount /= 100))
                    lease.otherDeposit.forEach((v) => (v.amount /= 100))
                    this.lease = lease
                })
                .then(() => {
                    if (houseId) this.showLease = true
                })
        },
        // 费用列表查询数据更改
        getExpenseSettlementList() {
            this.loadingExpenseSettlement = true

            // 新合约开始日期默认为费用清算日期的下一天
            var leaseStartDate = new Date(this.expenseSettlement.date)
            leaseStartDate.setDate(leaseStartDate.getDate() + 1)
            this.lease = {
                startDate: leaseStartDate,
                endDate:(dayjs(leaseStartDate).add(12, 'month')).add(-1,'day').toDate()
            }

            // 重新生成账单
            expenseBillListCreate({
                contractId: this.originalContract.id,
                changeDate: ymd(this.expenseSettlement.date),
                changeType: CONTRACT_CHANGE_TYPE.exchange,
                depositHandleType: this.expenseSettlement.depositHandleType[0],
            })
                .then((res) => {
                    // 押金是否已收
                    if (res.data.deposit) {
                        this.isRecvDeposit = res.data.deposit.billStatus === '2'
                    }
                    initExpenseSettlement(res, this.expenseSettlement)
                })
                .finally(() => {
                    this.loadingExpenseSettlement = false
                })
        },
        // 费用列表相关数据更改
        expenseDataChange() {
            const list = this.expenseSettlement.list

            list.forEach((v) => {
                // 只要是退款，账单状态改为未付
                if (v.isReceive === '2') {
                    v.planAmount = v.refund
                    v.billStatus = '3'
                }
                // 是收款，账单状态改为未收
                else if (v.isReceive === '1') {
                    v.planAmount = v.receivables
                    v.billStatus = '1'
                }
            })
        },
        // 格式化view数据
        formateView(view, expenseSettlement) {
            const {
                entity,
                contractCus,
                facilityList,
                contractLease,
                leftList,
            } = view.data
            const leftAmount =
                expenseSettlement.data.deposit?.planAmount / 100 || 0
            var tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)

            // 合同开始结束日期
            this.startDate = contractLease.startDate
            this.endDate = contractLease.endDate
            // 合同
            this.originalContract = entity
            // 客户
            Object.keys(contractCus).forEach((name) => {
                contractCus[name] = contractCus[name] || ''
            })
            this.cus = contractCus
            // 租约
            facilityList.forEach((v) => {
                v.parentId = v.pid
                v.price /= 100
            })

            formateLeaseReverse(contractLease)
            this.originalLease = contractLease
            this.originalLease.leaseDate = `${this.originalLease.startDate} 至 ${this.originalLease.endDate}`
            this.originalLease.signUser = entity.signUser
            this.originalLease.fList = facilityList
            this.originalLease.agentUser = this.$store.state.user.info.nickName

            this.lease = {
                // 新合约默认未开始日期为清算日期+1天
                startDate: tomorrow,
                // 新合同结算金额为原合同押金（已收）+增收押金（已收）由接口获取，新合同押金为0
                depositPayMethod: contractLease.depositPayMethod,
                rentPayMethod: contractLease.rentPayMethod,
                leftAmount,
                deposit: 0,
                addAmount: 0,
            }
            // 原合同结转金额=常规押金（未收为0）
            let totalDeposit = 0
            let leftAmountTextArr = []
            let feeTypeDict = this.dict.feeType
            leftList.forEach((v) => {
                // 常规押金
                if (v.feeType === '2') {
                    totalDeposit += v.realAmount / 100 || 0
                    leftAmountTextArr.push(`${feeTypeDict.val(v.feeType)}`)
                }
            })
            // prettier-ignore
            this.leaseLeftAmountText = `${currency(totalDeposit)}元(${leftAmountTextArr.join(',')})`

            // 原合同押金总额=常规押金+增收押金+其它押金列表
            let totalDepositOriginal = 0
            let leftAmountTextArrOriginal = []
            leftList.forEach((v) => {
                totalDepositOriginal += v.planAmount / 100 || 0
                leftAmountTextArrOriginal.push(
                    `${feeTypeDict.val(v.feeType)} ${currency(
                        v.planAmount / 100 || 0
                    )}`
                )
            })
            this.leaseLeftAmountTextOriginal = `${currency(
                totalDepositOriginal
            )}(${leftAmountTextArrOriginal.join(',')})`
        },
        // 读数清算初始化
        initExpenseSettlement(val) {
            const list = val.data.list || []
            list.forEach((v) => {
                v.planAmount /= 100
                v.realAmount /= 100
                // isReceive：1 收款，2 退款
                // 应收/未收
                if (v.billStatus === '1' || v.billStatus === '6') {
                    v.amount = v.planAmount
                    v.receivables = v.planAmount
                    v.refund = 0
                    v.isReceive = '1'
                }

                // 已收
                if (v.billStatus === '2') {
                    v.amount = v.planAmount
                    v.receivables = 0
                    v.refund = v.planAmount
                    v.isReceive = '2'
                }

                // 应付/未付
                if (v.billStatus === '3' || v.billStatus === '7') {
                    v.amount = v.planAmount
                    v.receivables = 0
                    v.refund = v.planAmount
                    v.isReceive = '2'
                }
            })
            this.expenseSettlement.list = list
        },
        // 抄表初始化
        initMeterSettlement(val) {
            const list = val.data.list || []
            list.forEach((v) => {
                const meter = this.dict.meterType.get(v.meterType)
                v.unit = '元/' + JSON.safeParse(meter?.remark).unit
                v.price = v.price ? v.price / 100 : 0
                v.amount = v.amount ? v.amount / 100 : ''
            })
            this.meterSettlement = list
        },
        // 提交-显示修改账单
        submit() {
            this.$refs.info
                .validate()
                .then(() => {
                    this.chargeDetails = []
                    const list = this.expenseSettlement.list

                    // 费用清算-收款列表
                    let refundList = list.filter((v) => v.isReceive === '1')
                    refundList = this.mergeBill(refundList)
                    this.getChargeDetailsList(
                        this.chargeDetails,
                        refundList,
                        '实际收款费用'
                    )
                    //  费用清算-退款列表
                    let paidList = list.filter((v) => v.isReceive === '2')
                    paidList = this.mergeBill(paidList)
                    this.getChargeDetailsList(
                        this.chargeDetails,
                        paidList,
                        '实际退款费用'
                    )
                    // 抄表费用
                    let meterList = deepCopy(this.meterSettlement)
                    this.getChargeMeterList(
                        this.chargeDetails,
                        meterList,
                        '抄表费用'
                    )
                    this.modal.showChargeDetails = true
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 合并相同的费用
        mergeBill(list) {
            list = deepCopy(list)
            const feeTypeObj = {}
            const newList = []
            list.forEach((v) => {
                if (feeTypeObj[v.feeType] === true) {
                    const item = newList.find((p) => p.feeType === v.feeType)
                    item.planAmount =
                        parseFloat(item.planAmount) + parseFloat(v.planAmount)
                } else {
                    newList.push(v)
                    feeTypeObj[v.feeType] = true
                }
            })
            return newList
        },
        // 费用清算列表——收款退款
        getChargeDetailsList(chargeDetails, list, title) {
            if (list.length > 0) {
                const obj = {
                    title,
                    list: [],
                }
                // 一行5个数据
                let newItem = true
                list.forEach((v) => {
                    if (newItem) {
                        obj.list.push([])
                        newItem = false
                    }
                    obj.list[obj.list.length - 1].push({
                        text: this.dict.feeType.val(v.feeType),
                        val: currency(v.planAmount) + '元',
                    })
                    if (obj.list[obj.list.length - 1].length === 5) {
                        newItem = true
                    }
                })
                chargeDetails.push(obj)
            }
        },
        // 费用清算列表——抄表
        getChargeMeterList(chargeDetails, list, title) {
            if (list.length > 0) {
                const obj = {
                    title,
                    list: [],
                }

                list.forEach((v) => {
                    obj.list.push([
                        {
                            text: v.meterName,
                            val: '',
                        },
                        {
                            text: '上次读数',
                            val: v.lastDegree,
                        },
                        {
                            text: '本次读数',
                            val: v.degree,
                        },
                        {
                            text: '单价',
                            val: v.price,
                        },
                        {
                            text: '合计',
                            val:
                                v.amount === ''
                                    ? ''
                                    : currency(v.amount) + '元',
                        },
                    ])
                })
                chargeDetails.push(obj)
                chargeDetails.remark = ''
            }
        },
        //打开账单修正
        popChange() {
            this.modal.showBillCorrection = true
        },
        // 预览合同
        view() {
            this.$refs.info
                .validate()
                .then(() => {
                    const data = deepCopy(this.$refs.info.populateData())
                    // deposit没有地方显示，数据采集采集不到，生成账单不含;但是在账单平移的时候有，显示
                    data.lease.deposit = data.lease.deposit || 0

                    formateContractAndView(data)
                    data.bills = deepCopy(this.bills.concat(this.payBills))
                    data.bills.forEach((v) => {
                        v.title = ''
                        v.periodText = ''
                        v.bill = ''
                    })
                    const formData = {
                        contract: JSON.stringify(data.contract),
                        cus: JSON.stringify(data.cus),
                        lease: JSON.stringify(data.lease),
                        facility: JSON.stringify(data.facility),
                        bills: JSON.stringify(data.bills),
                    }
                    contractPriview(formData).then((res) => {
                        window.open(officePreview(res.data.path))
                    })
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 创建账单
        createBill: debounce(500, function () {
            var formData = deepCopy(this.$refs.info.populateData()),
                billData = formData.lease
            if (!billData) return

            // 押金
            billData.deposit = billData.deposit || 0
            // 支持换房抵扣场景
            var {
                depositHandleType,
                isDeductionByLast,
            } = this.expenseSettlement // 清算信息

            Object.assign(billData, {
                isDeductionByLast, // 是否抵租金
                liquidation: JSON.stringify(this.populateLiquidationForBill()), // 清算数据
                changeType: CONTRACT_CHANGE_TYPE.exchange, // 操作类型 1-换房
                depositHandleType: depositHandleType.join(','), // 押金处理方式
            })
            this.createContractBill(billData)
        }),
        // 换房
        contractCreate() {
            const data = deepCopy(this.$refs.info.populateData())
            this.formatePopulateData(data)
            this.metersJSON = JSON.stringify(data.meters)
            data.liquidation.push({ remark: this.remark })
            const formData = {
                contractId: this.routerContractId,
                contract: JSON.stringify(data.contract),
                cus: JSON.stringify(data.cus),
                lease: JSON.stringify(data.lease),
                facility: JSON.stringify(data.facility),
                bills: JSON.stringify(data.bills),
                change: JSON.stringify(data.change),
                liquidation: JSON.stringify(data.liquidation),
                meters: this.metersJSON,
                agentUser: data.agentUser,
                changeType: CONTRACT_CHANGE_TYPE.exchange,
                depositHandleType: this.expenseSettlement.depositHandleType[0],
            }

            return contractChangeHouse(formData)
        },
        // 格式化
        formatePopulateData(data) {
            // deposit没有地方显示，数据采集采集不到，为0；可以采集到，则显示对应的
            data.lease.deposit = data.lease.deposit || 0
            formateContractAndView(data)
            data.agentUser = data.leaseOriginal.agentUser
            data.bills = deepCopy(this.bills.concat(this.payBills))
            data.bills.forEach((v) => {
                v.title = ''
                v.periodText = ''
                v.bill = ''
            })
            data.change = {
                changeType: CONTRACT_CHANGE_TYPE.exchange,
                changeDate: ymd(this.expenseSettlement.date),
                changeReason: data.leaseOriginal.changeReason,
            }
            const liquidation = formateExpenseSettlement(
                this.expenseSettlement.list
            )
            data.liquidation = []
            liquidation.forEach((v) => {
                data.liquidation.push({
                    startDate: v.startDate,
                    endDate: v.endDate,
                    feeType: v.feeType,
                    planAmount: v.planAmount,
                    billStatus: v.billStatus,
                    isReceive: v.isReceive,
                })
            })
            data.meters = formateMeterSettlement(this.meterSettlement)
        },
        // 确认账单修改，返回合同管理
        toContract() {
            this.modal.showChargeDetails = false
            this.contractCreate()
                // .then(() => {
                //     return meterListUpdate(this.metersJSON);
                // })
                .then(() => {
                    this.$Message.success('换房成功')
                    this.$router.push({
                        name: 'contractIndex',
                    })
                })
        },
        // 生成账单所需的清算数据
        populateLiquidationForBill() {
            return this.expenseSettlement.list.map((v) => ({
                feeType: v.feeType,
                planAmount: cent(v.planAmount),
                billStatus: v.billStatus,
            }))
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
}
</style>
